import type { ThemeDefinition } from 'vuetify';

export const mainTheme: ThemeDefinition = {
  dark: false,
  colors: {
    'primary-100': '#9ed4ea',
    'primary-150': '#bee5eb',
    'primary-200': '#99ddf8',
    'primary-300': '#3a8fbf',
    'primary-400': '#17a2b8',
    'primary-500': '#3b6692',
    'primary-600': '#0056b3',
    primary: '#218ebd',
    'success-100': '#e3ede2',
    'success-150': '#e6f5e9',
    'success-200': '#aac5aa',
    'success-250': '#dce6db',
    'success-300': '#28a745',
    'success-350': '#28a770',
    'success-400': '#218838',
    'success-450': '#d6efdd',
    'success-500': '#acc5a9',
    'success-550': '#c3e6cb',
    'success-600': '#155724',
    success: '#41a76e',
    'error-light': '#f8d7da',
    'error-100': '#fcedee',
    'error-200': '#f9dadd',
    'error-300': '#eadadc',
    'error-400': '#f5c6cb',
    'error-600': '#721c24',
    grey: '#f5f5f5',
    'grey-100': '#e2e2e2',
    'grey-150': '#bbb5b5',
    'grey-200': '#f7f7f7',
    'grey-250': '#4c4c4c',
    'grey-300': '#d6d8db',
    'grey-350': '#6c757d',
    'grey-400': '#9f9f9f',
    'grey-450': '#e8e9e9',
    'grey-500': '#808080',
    'grey-600': '#4e4e4eb3',
    'grey-650': '#e9ecef',
    'grey-700': '#bfd0ec',
    'grey-750': '#e0e0e0',
    'grey-800': '#eee',
    'grey-850': '#d3d7de',
    'grey-900': '#aaa',
    'grey-920': '#5a5c66',
    'grey-950': '#3c3f48',
    'grey-1000': '#767982',
    'green-500': '#aac5aa',
    'red-500': '#f8d7da',
    'red-600': '#dc3545',
    'warning-100': '#ffeeba',
    'warning-300': '#ffc107',
    'info-light': '#e5f4f7',
    'label-text': '#212529',
    'text-color': '#212529',
    'tabulator-row-dark': '#6a6c73',
    'tabulator-odd-row-dark': '#363941',
    neutral: '#888888',
    'dark-background': '#212329'
  }
};

export const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    ...mainTheme.colors,
    primary: '#43b3e8',
    'label-text': '#d3d7de',
    'text-color': '#d3d7de'
  }
};
